import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBackArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={9}
    fill="none"
    viewBox="0 0 19 9"
    {...props}
  >
    <path
      fill="#212121"
      d="M6.777 1.536c.464-.351.464-.92 0-1.272s-1.215-.352-1.68 0l-4.75 3.6C.126 4.032 0 4.26 0 4.5s.125.468.348.636l4.75 3.6c.464.352 1.215.352 1.68 0 .463-.351.463-.92 0-1.272L4.053 5.4h13.759c.655 0 1.187-.403 1.187-.9s-.532-.9-1.187-.9H4.053z"
    />
  </svg>
);
export default SvgBackArrowIcon;
